import accounting from 'accounting'

export default (value) => {
  return accounting.formatNumber(value, 2, ' ', ',')
}
